
import BaseNavigationComponent from "@/components/BaseNavigation/BaseNavigationComponent";
export default BaseNavigationComponent;
